import gql from "graphql-tag";
import { createBoundMutation } from "./util";

const signUp = gql`
  mutation signUp($phoneNumber: String, $countryId: Int) {
    signUp(phoneNumber: $phoneNumber, countryId: $countryId)
  }
`;

const signIn = gql`
  mutation signIn($userName: String, $password: String) {
    signIn(userName: $userName, password: $password)
  }
`;

const forgotPassword = gql`
  mutation forgotPassword($identifier: String) {
    forgotPassword(identifier: $identifier)
  }
`;

const changePassword = gql`
  mutation changePassword(
    $oldPassword: String
    $newPassword: String
    $confirmNewPassword: String
  ) {
    changePassword(
      old_password: $oldPassword
      new_password: $newPassword
      confirm_new_password: $confirmNewPassword
    )
  }
`;

export namespace authMutations{
  export interface SignUpArgs {
    phoneNumber: string;
    countryId: number;
  }
  export const SignUpMutation = createBoundMutation<void, SignUpArgs>({
    mutation: signUp
  });

  export interface SignInArgs {
    userName: string;
    password: string;
  }
  export interface SignInData {
    signIn: string;
  }
  export const SignInMutation = createBoundMutation<SignInData, SignInArgs>({
    mutation: signIn
  });

  interface ForgotPasswordArgs {
    identifier?: string | null;
  }

  export const ForgotPassword = createBoundMutation<any, ForgotPasswordArgs>({
    mutation: forgotPassword
  });
  export interface ChangePasswordArgs {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
  }

  export const ChangePassword = createBoundMutation<void, ChangePasswordArgs>({
    mutation: changePassword
  });
}


// WEBPACK FOOTER //
// ./src/api/auth.ts